/**
 * <brand-marquee> — "Nuestras marcas" logo strip (sections/brand-grid.liquid).
 *
 * The scrolling itself is CSS. This element only:
 *  - sets --brand-marquee-duration so the speed in px/s (data-speed, a Theme Editor setting) stays the same whatever
 *    the width of the strip (duration = width of one pass / speed), and keeps it right on resize;
 *  - pauses the animation while the strip is off screen (data-offscreen), so it does no work nobody can see.
 *
 * Without JavaScript the CSS default duration still runs the loop. Hover/focus pause and prefers-reduced-motion are
 * CSS too.
 */
if (!customElements.get('brand-marquee')) {
  customElements.define(
    'brand-marquee',
    class BrandMarquee extends HTMLElement {
      connectedCallback() {
        if (!this.hasAttribute('data-animate')) return;
        const pass = this.querySelector('.brand-grid__list');
        if (!pass) return;

        this.pass = pass;
        this.update = this.update.bind(this);

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(this.update);
          this.resizeObserver.observe(pass);
        }
        if ('IntersectionObserver' in window) {
          this.visibilityObserver = new IntersectionObserver(([entry]) => {
            this.toggleAttribute('data-offscreen', !entry.isIntersecting);
          });
          this.visibilityObserver.observe(this);
        }
        this.update();
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
        this.visibilityObserver?.disconnect();
      }

      update() {
        const speed = Number(this.dataset.speed) || 50;
        const width = this.pass.getBoundingClientRect().width;
        if (width > 0) {
          this.style.setProperty('--brand-marquee-duration', `${(width / speed).toFixed(2)}s`);
        }
      }
    }
  );
}
